import React from 'react';
import PrimaryButton from './PrimaryButton';
import { menuData } from '../data/menuData';
import styled from 'styled-components';
import { HashLink } from 'react-router-hash-link';
import { Link } from 'react-router-dom';

function MenuItems() {
  return (
    <ItemsMenus>
      {menuData.map((item, index) => {
        return (
          <HashLink to={item.link} key={index} className="menu-items">
            {item.title}
          </HashLink>
        );
      })}
      <Link to="/login" className="nav-log">
        <PrimaryButton name={'Login'} />
      </Link>
    </ItemsMenus>
  );
}

const ItemsMenus = styled.div`
  display: none;
  z-index: 100;
  @media screen and (max-width: 1186px) {
    z-index: 100;
    display: grid;
    background: rgb(239, 239, 239);
    background: linear-gradient(
      180deg,
      rgba(239, 239, 239, 1) 0%,
      rgba(179, 193, 247, 1) 16%,
      rgba(31, 53, 246, 0.8491596467688638) 100%
    );
    position: fixed;
    padding-top: 80px;
    left: 0;
    justify-content: center;
    width: 100%;
    height: 100%;
    align-items: center;

    .menu-items {
      z-index: 100;
      color: #fff;
      display: flex;
      align-items: center;
      text-decoration: none;
      font-weight: bold;
      padding: 0 1rem;
      height: 100%;
      cursor: pointer;
      font-size: 2rem;
      justify-content: center;
      transition: all 0.3s ease-in-out;
      &:hover {
        color: #7199ff;
      }
    }
    .nav-log {
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 100;
    }
  }
`;

export default MenuItems;
